import { Modal } from "@aph/ui-lib-humanx";
import Profile from "@/components/ProfileSideDrawer/Profile";
import ProfileModalState from "@/components/ProfileSideDrawer/redux/selectors/profileModalState";
import { setIsProfileOpen } from "@/components/ProfileSideDrawer/redux/slice";
import { DeviceInfo } from "@/interface/deviceInfo";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import styles from "./ProfileSideDrawer.module.scss";
interface ProfileSideDrawerInterface {
  ua: DeviceInfo;
  isLoggedIn?: boolean;
  isUserFromApp?: boolean;
}

const ProfileSideDrawer = (props: ProfileSideDrawerInterface) => {
  const { ua, isUserFromApp } = props;
  const isProfileOpen = useAppSelector(ProfileModalState);
  const dispatch = useAppDispatch();

  return (
    <>
      <Modal
        open={isProfileOpen}
        size="sm"
        handleOpen={() => {
          dispatch(setIsProfileOpen(false));
        }}
        backdropClose={true}
        titleClass={styles.titleClass}
        titleAlign="left"
        modalRightAlign
        fullHeight={ua?.isDesktop}
        fullPage={ua?.isMobile}
        closeIconHide
        modalContentClass={styles.modalContentClass}
        modalboxClass={styles.modalboxClass}
      >
        <Profile ua={ua} isUserFromApp={isUserFromApp} />
      </Modal>
    </>
  );
};

export default ProfileSideDrawer;
